import React from 'react';

const Footer = () => {
  return (
    <footer className="text-center text-gray-200 text-sm font-extralight py-4">
      © 2025 Christian Care for Children & Elders Association. All Rights Reserved.
    </footer>
  );
};

export default Footer;
